import { render, staticRenderFns } from "./createUserId.vue?vue&type=template&id=485e8c02&"
import script from "./createUserId.vue?vue&type=script&lang=js&"
export * from "./createUserId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/system/createUserId.vue"
export default component.exports